import moment from "moment";

function dateTimeInput() {
	return {
		restrict: "A",
		require: "ngModel",
		link() {
			const formatters = {
				["date"](input) {
					return moment(input).format("L");
				},
				["time"](input) {
					const matchableRegex = /^0?([1-9]|1[0-2])(?::?([0-5][0-9]))?\s?((?:[A|a]|[P|p])(?:[M|m]?))$/g;
					if(!input.match(matchableRegex)) {
						return input;
					}

					return input.replace(matchableRegex, (x, hours, mins, period) => {
						mins = mins || "00";
						period = `${period}${period
							.toUpperCase()
							.includes("M") ? "" : "M"}`;

						return `${hours}:${mins} ${period}`.toUpperCase();
					});
				},
				["date-time"](input) {
					const [date, ...timePieces] = input.split(" ");
					const time = timePieces.join(" ");

					return `${formatters.date(date)} ${formatters.time(time)}`;
				}
			};

			// element.on('blur', () => {
			// const formatter = formatters[attrs.dateTime];
			// if (!formatter) {
			//   return;
			// }
			// const value = formatter(ngModel.$modelValue);
			// element.val(value);
			// ngModel.$setViewValue(value);
			// scope.$evalAsync();
			// });
		}
	};
}

export default angular
	.module("vesl.behaviors.date-time-input", [])
	.directive("dateTimeInput", dateTimeInput).name;
